import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const JoinPage = () => {
  useEffect(() => {
    document.title = '사용자 가입';
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <div>
        <div className="page-title-wrap" data-type="responsive">
          <h2 className="h-tit">사용자 가입</h2>
        </div>
        <ol className="step-wrap">
          <li className="active">
            <span>
              <i className="sr-only">1단계 현재단계</i>
              <span className="step-tit">가입 유형 선택</span>
            </span>
          </li>
          <li>
            <span>
              <i className="sr-only">2단계</i>
              <span className="step-tit">중복가입 확인</span>
            </span>
          </li>
          <li>
            <span>
              <i className="sr-only">3단계</i>
              <span className="step-tit">약관동의</span>
            </span>
          </li>
          <li>
            <span>
              <i className="sr-only">4단계</i>
              <span className="step-tit">정보입력</span>
            </span>
          </li>
          <li>
            <span>
              <i className="sr-only">5단계</i>
              <span className="step-tit">사용자 가입 완료</span>
            </span>
          </li>
        </ol>

        <h3 className="content-tit">사용자 가입을 환영합니다.</h3>
        <p className="text-gray-70">사용자 가입 유형을 선택해 주세요.</p>

        <div className="txt-box bg-white gap-md select-join-type">
          <dl>
            <dt>
              <i className="ico-join-corp"></i>
              기업 사용자
            </dt>
            <dd>
              <span
                className="btn md primary"
                onClick={() => {
                  navigate('/member/entJoinBRNO', {
                    state: { mode: 'ent' },
                  });
                }}
              >
                가입하기
              </span>
            </dd>
          </dl>
          <span className="vr"></span>
          {/* <dl>
            <dt>
              <i className="ico-join-user"></i>
              일반사용자
            </dt>
            <dd>
              <span
                className="btn md primary"
                onClick={() => {
                  navigate('/member/joinEmlChk', {
                    state: { mode: 'gen' },
                  });
                }}
              >
                가입하기
              </span>
            </dd>
          </dl>
          <span className="vr"></span> */}
          <dl>
            <dt>
              <i className="ico-join-expt"></i>
              전문가
            </dt>
            <dd>
              <span
                className="btn md primary"
                onClick={() => {
                  navigate('/member/joinEmlChk', {
                    state: { mode: 'expt' },
                  });
                }}
              >
                가입하기
              </span>
            </dd>
          </dl>
        </div>
      </div>
    </>
  );
};

export default JoinPage;
